import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "../../lib/utils";

const Switch = React.forwardRef(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    className={cn(
      "group inline-flex h-6 w-11 shrink-0 origin-center cursor-pointer items-center rounded-full border-2 transition-colors duration-200 ease-out",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ui-ring focus-visible:ring-offset-2 focus-visible:ring-offset-ui-background",
      "disabled:cursor-not-allowed disabled:opacity-50",
      /* Off: track reads as a control, not a hole in the page */
      "data-[state=unchecked]:border-ui-border data-[state=unchecked]:bg-ui-card",
      "data-[state=checked]:border-accent data-[state=checked]:bg-accent",
      className
    )}
    ref={ref}
    {...props}
  >
    <SwitchPrimitive.Thumb
      className={cn(
        "pointer-events-none block h-4 w-4 rounded-full border shadow-sm ring-0 transition-transform duration-200 ease-out",
        "border-border/60 group-data-[state=unchecked]:bg-tertiary",
        "group-data-[state=checked]:border-ui-border group-data-[state=checked]:bg-text-on-accent",
        "group-data-[state=unchecked]:translate-x-0.5 group-data-[state=checked]:translate-x-5"
      )}
    />
  </SwitchPrimitive.Root>
));
Switch.displayName = SwitchPrimitive.Root.displayName;

export { Switch };
